module.exports = __webpack_public_path__ + "static/11-6280c35d00109644954a5fa424d211f1.jpg";